module.exports = __webpack_public_path__ + "img/icon_001@2x.f15f5fb8.png";